import {
    BaseError,
} from 'wanderu-utils';

export class FormIsEmptyError extends BaseError {
    constructor() {
        super('Form had no values defined or were empty strings');
    }
}

export class MoreThanOneChildError extends BaseError {
    constructor() {
        super('Validate expects one child to augment');
    }
}

export class MoreThanOneInputError extends BaseError {
    constructor(inputClassName) {
        super(`Form Component can only have 1 Input component of class ${inputClassName} inside a Validate component.`);
    }
}

export class NoKeyError extends BaseError {
    constructor(child) {
        super(`Input's must have a key or when used with the Form or Validate component This was the input: ${JSON.stringify(child)}`);
    }
}
